/**
 * BL-177 Gate 18 — write-time folder rows for email conversations.
 * Dependency-free so both the browser bundle and the Deno Edge Functions
 * (via emailIntake.js) can import it.
 */
export const DEFAULT_INBOUND_EMAIL_FOLDER = 'Inbox';

export function normalizeEmailFolderName(folderName) {
  const trimmed = typeof folderName === 'string' ? folderName.trim() : '';
  if (!trimmed || trimmed.length > 255) return DEFAULT_INBOUND_EMAIL_FOLDER;
  return trimmed.toLowerCase() === 'inbox' ? DEFAULT_INBOUND_EMAIL_FOLDER : trimmed;
}

/**
 * Gives an email conversation its folder row at write time. The Supabase
 * client is injected so this file stays SDK-free. ignoreDuplicates keeps any
 * folder a staff member already chose for the conversation.
 */
export async function ensureEmailConversationFolder(supabase, { orgId, mailboxId, sessionId, folderName } = {}) {
  if (!supabase || !orgId || !mailboxId || !sessionId) {
    return { ok: false, skipped: true, error: null };
  }
  const { error } = await supabase
    .from('org_email_conversation_folders')
    .upsert({
      org_id: orgId,
      mailbox_id: mailboxId,
      session_id: sessionId,
      folder_name: normalizeEmailFolderName(folderName),
    }, { onConflict: 'session_id', ignoreDuplicates: true });
  return { ok: !error, skipped: false, error: error || null };
}
